import customerarchives from './customerarchives'
export default customerarchives
